







































































































import { Teacher } from '../../../src_server/entity/generated/Teacher';
import { Component, Prop } from 'vue-property-decorator';
import { InputPages } from '../../components/organisms/InputPages';
import { TeacherFileDTO } from '../../../src_server/entity/dto/TeacherFileDTO';
import ErrorSummary from '../../components/inputs/ErrorSummary.vue';

@Component({ components: { ErrorSummary } })
export default class AdditionalInfoPage extends InputPages {
  @Prop()
  value!: Teacher;
  @Prop()
  private file!: TeacherFileDTO;

  // async commitBasicDay() {
  //   const biz = new ShiftTableService();
  //   const dayOfWeekMonstart: boolean[] = this.basicWorkDayOfWeek.map((w) => {
  //     return w.value;
  //   });
  //   await biz.commitBasicDay(Session.getSessionUserId(), dayOfWeekMonstart);
  //   this.isCommitedBasicDay = true;
  //   MessageDialog.alert('基本稼働日を設定しました。').then();
  // }

  async movieInput(event: Event) {
    // console.log(event);
    const files = (event.target as HTMLInputElement)?.files;
    if (!files) return;
    const file = files[0];
    this.fileModel.movie_client_url = URL.createObjectURL(file);
    this.fileModel.movie_file = file;
  }

  get model() {
    return this.value;
  }

  set model(value) {
    this.$emit('input', value);
  }

  get fileModel() {
    return this.file;
  }

  set fileModel(value) {
    // this.file = value;
    this.$emit('file-upload', value);
  }

  helpZoom() {
    window.open('https://docs.google.com/document/d/1g6xoADaCY-TAo1p_n1YZ3cWOUECYEUUFGfFutjN-2wM/edit', '_blank');
  }
}
